
import React from 'react'
import PropTypes from 'prop-types'
import { Flex } from '@elparking/components'
import VehicleTypeCard from './VehicleTypeCard'
import styled from 'styled-components'
import { FormattedMessage } from 'react-intl'
import VehicleVan from './icons/VehicleVan'
import VehicleCompact from './icons/VehicleCompact'
import { RentalCarEvents, trackTealiumEvent } from 'commons/js/services/analytics'

const VehicleTypeSelectorContainer = styled(Flex)`
    gap: 0px;
`

const defaultVehicleTypes = {
    car: {
        icon: VehicleCompact,
        label: <FormattedMessage defaultMessage='Coches' />,
    },
    van: {
        icon: VehicleVan,
        label: <FormattedMessage defaultMessage='Furgonetas' />,
    },
}

export const VehicleTypeFilter = ({ vehicleType, setVehicleType, isModal, isLoading }) => {
    return <VehicleTypeSelectorContainer justifyContent='space-between' flexWrap='wrap' width='fit-content'>
        {Object.keys(defaultVehicleTypes).map((type) => <VehicleTypeCard
          checked={type === vehicleType}
          icon={defaultVehicleTypes[type].icon}
          label={defaultVehicleTypes[type].label}
          key={`vehicle_type_${type}`}
          keyId={type + isModal}
          type='radio'
          onChange={() => {
            trackTealiumEvent(RentalCarEvents.applyFiltersLink)
            setVehicleType(type)
            }}
          isLoading={isLoading}
        />)
        }
    </VehicleTypeSelectorContainer>
}

VehicleTypeFilter.propTypes = {
    vehicleType: PropTypes.string,
    setVehicleType: PropTypes.func,
    isModal: PropTypes.bool,
    isLoading: PropTypes.bool,
}

export {
    defaultVehicleTypes,
}

export default VehicleTypeFilter
